import React from 'react';
import { UserIcon } from '@heroicons/react/24/outline';

const Users: React.FC = () => {
  return (
    <div className="section-card">
      <h1 className="section-title">Users</h1>
      <p className="section-description">
        Manage user accounts, permissions, and access levels within the system.
      </p>

      <div className="mt-8">
        <h2 className="text-xl font-semibold text-gray-800 mb-4">
          Features
        </h2>
        <div className="space-y-4">
          <div className="feature-item">
            <UserIcon className="feature-icon" />
            <div className="feature-text">
              <h3 className="feature-title">User Management</h3>
              <p className="feature-description">
                Handle user accounts and profiles:
              </p>
              <ul className="list-disc list-inside mt-2 text-gray-600">
                <li>Create and edit user accounts</li>
                <li>Manage user profiles</li>
                <li>Set user permissions</li>
                <li>Track user activity</li>
              </ul>
            </div>
          </div>

          <div className="feature-item">
            <UserIcon className="feature-icon" />
            <div className="feature-text">
              <h3 className="feature-title">Access Control</h3>
              <p className="feature-description">
                Manage user access and security:
              </p>
              <ul className="list-disc list-inside mt-2 text-gray-600">
                <li>Configure role-based access</li>
                <li>Set security policies</li>
                <li>Manage authentication</li>
                <li>Monitor user sessions</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-8">
        <h2 className="text-xl font-semibold text-gray-800 mb-4">
          Best Practices
        </h2>
        <div className="bg-blue-50 p-4 rounded-lg">
          <ul className="list-disc list-inside space-y-2 text-blue-800">
            <li>Follow principle of least privilege</li>
            <li>Regularly review user access</li>
            <li>Maintain strong password policies</li>
            <li>Keep user information secure</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Users; 